/**
 * Download a blob as a file with the given filename.
 */
export function downloadBlob(blob: Blob, filename: string) {
  const anchor = document.createElement('a');
  document.body.appendChild(anchor);
  const objectUrl = window.URL.createObjectURL(blob);
  anchor.href = objectUrl;
  anchor.download = filename;
  anchor.click();
  window.URL.revokeObjectURL(objectUrl);
  document.body.removeChild(anchor);
}

export function downloadFromUrl(href: string, filename?: string) {
  const anchor = document.createElement('a');
  anchor.href = href;

  if (filename) {
    anchor.download = filename;
  }

  anchor.click();
}
